/** AI chat: ChatPage, ChatPanel, Thread, Composer, ContextPicker, TokenMeter, PromptLibraryPage. */
export const ai = {
  'ai.composer.send': 'Send',
  'ai.composer.stop': 'Stop',
  'ai.composer.placeholder': 'Ask your notes a question…',
  'ai.composer.rateLimited': 'Too many requests. Try again in {seconds} seconds.',
  'ai.composer.overBudget': 'Context is over budget. Deselect a page to send.',
  'ai.composer.hint': 'Enter to send · Shift+Enter for a newline',
  'ai.composer.promptLabel': 'Prompt',
  'ai.composer.promptDefault': 'Default',
  'ai.composer.promptDefaultSuffix': ' · default',
  'ai.composer.modelLabel': 'Model',

  'ai.chat.new': 'New conversation',
  'ai.chat.newWithPage': 'New conversation with this page attached',
  'ai.chat.openFull': 'Open in full view',
  'ai.chat.conversations': 'Conversations',
  'ai.chat.noConversations': 'No conversations yet.',
  'ai.chat.delete': 'Delete {title}',
  'ai.chat.pageCount.one': '{count} page',
  'ai.chat.pageCount.other': '{count} pages',
  'ai.chat.emptyTitle': 'Ask your notes a question.',
  'ai.chat.emptyBody':
    'Attach pages as context, pick a prompt, and Claude answers from what you’ve written.',

  'ai.context.attach': 'Attach a page as context…',
  'ai.context.attachLabel': 'Attach a page as context',
  'ai.context.noMatch': 'No pages match “{query}”.',
  'ai.context.pages': 'Pages',
  'ai.context.heading': 'Context',
  'ai.context.attachPage': 'Attach page',
  'ai.context.emptyTitle': 'No context attached yet.',
  'ai.context.emptyBody': 'Attach a page and ask something.',
  'ai.context.attachThisPage': 'Attach “{title}”',
  'ai.context.thisPage': 'this page',
  'ai.context.untitled': 'Untitled',
  'ai.context.tokens': '{count} tok',
  'ai.context.detach': 'Detach {title}',
  'ai.context.page': 'page',
  'ai.context.includeDescendants': 'Include descendants',
  'ai.context.expanded': ' · + {count} pages',
  'ai.context.imagesNotSent': 'Images are not sent — Claude sees their alt text only.',

  'ai.tokenMeter.context': 'Context',
  'ai.tokenMeter.ariaLabel': '{total} of {limit} context tokens',
  'ai.tokenMeter.overBudget':
    'Context is over budget — {total} of {limit} tokens. Deselect a page to send.',
  'ai.tokenMeter.warn':
    'Large context — every turn re-reads this. Cached turns cost about a tenth as much, but the first one is full price.',

  'ai.thread.copy': 'Copy',
  'ai.thread.copied': 'Copied.',
  'ai.thread.copyFailed': "Couldn't copy.",
  'ai.thread.noAnswer': 'No answer was produced.',
  'ai.thread.stopped': 'Stopped.',
  'ai.thread.waitingForFirstToken': 'Waiting for the first token',
  'ai.thread.jumpToLatest': 'Jump to latest',
  'ai.thread.inputTokens': 'input tokens',
  'ai.thread.outputTokens': 'output tokens',
  'ai.thread.cachedTitle': 'read from the prompt cache',
  'ai.thread.cached': '{count} cached',

  'ai.prompts.settings': 'Settings',
  'ai.prompts.title': 'Prompt library',
  'ai.prompts.name': 'Name',
  'ai.prompts.body': 'Body',
  'ai.prompts.defaultPrompt': 'Default prompt',
  'ai.prompts.defaultPromptHint': '— pre-selected on a new conversation.',
  'ai.prompts.deletePrompt': 'Delete prompt',
  'ai.prompts.deleteTitle': 'Delete the “{name}” prompt?',
  'ai.prompts.deleteDescPre': 'Conversations that used it are ',
  'ai.prompts.deleteDescStrong': 'not',
  'ai.prompts.deleteDescPost':
    ' deleted — they keep their history and fall back to the built-in prompt on their next turn.',
  'ai.prompts.namePlaceholder': 'Lore Keeper, Session Recap…',
  'ai.prompts.bodyPlaceholder': 'You are…',
  'ai.prompts.createPrompt': 'Create prompt',
  'ai.prompts.default': 'Default',
  'ai.prompts.newPrompt': 'New prompt',
  'ai.prompts.empty': 'No prompts yet. Create one to get started.',

  'ai.toast.conversationStartFailed': "Couldn't start the conversation.",
  'ai.toast.conversationUpdateFailed': "Couldn't update the conversation.",
  'ai.toast.conversationDeleteFailed': "Couldn't delete the conversation.",
  'ai.toast.promptSaveFailed': "Couldn't save the prompt.",
  'ai.toast.promptDeleteFailed': "Couldn't delete the prompt.",
} as const;
